import { postRequest } from '@/core';
import { transporterOrders } from '@/requests';

export default async function newTransporterOrderRequest(data) {
	let url = transporterOrders.getPath();
	let response = await postRequest(url, {}, data);
	return response;
}
